import * as React from "react";
const SvgHideNavigation = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 15, viewBox: "0 0 12 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 4L4 8L8 12", stroke: "currentColor" }));
export default SvgHideNavigation;
